import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import axios from "axios";

import useAuth from "../../hooks/useAuth";

// Images
import bgImage from "assets/images/stock-market.jpg";

const LoginPage = () => {
  const [loginURL, setLoginURL] = useState("");
  const [searchParams] = useSearchParams();
  const hasCalled = useRef(false);
  // const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const getGoogleLoginURL = async () => {
      const urlData = await axios.get("/api/googleapi/url/");
      setLoginURL(urlData.data.url);
    };
    getGoogleLoginURL();
  }, []);

  useEffect(() => {
    if (hasCalled.current) return;
    hasCalled.current = true;

    const getAuthedUser = async () => {
      const paramEntries = searchParams.entries();
      let params = {};
      for (const entry of paramEntries) {
        params[entry[0]] = entry[1];
      }
      const code = params.code;
      if (code) {
        const calledKey = `google_auth_called_${code}`;
        if (sessionStorage.getItem(calledKey) === "1") return;

        sessionStorage.setItem(calledKey, "1");
        await login(params);
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };
    getAuthedUser();
  }, [searchParams, login]);

  return (
    <MKBox component="header" position="relative">
      <MKBox
        display="flex"
        alignItems="center"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ palette: { gradients }, functions: { linearGradient, rgba } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.5),
              rgba(gradients.dark.state, 0.5)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} md={7} lg={6} flexDirection="column" justifyContent="center">
            <MKTypography
              variant="h1"
              color="white"
              mb={3}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              New Platform
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} pr={6} mr={6}>
              Welcome to new platform. You can see all data in one place
            </MKTypography>
            <Stack direction="row" spacing={1} mt={3}>
              <MKButton color="white">
                <a href={loginURL}>Login with google</a>
              </MKButton>
            </Stack>
          </Grid>
        </Container>
      </MKBox>
    </MKBox>
  );
};

export default LoginPage;
